import { isEmpty } from "lodash";
import { useConfirmTransaction } from "hooks/useConfirmTransaction";
import GeneralCredentialForm from "pages/_components/Forms/GeneralCredentialForm";
import { ResponsiveHeader } from "pages/_components/header";
import Loader from "pages/_components/Loader";
import MainContainer from "pages/_components/MainContainer";
import Notification from "pages/_components/Notification";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { actions as contactActions } from "reducers/contactDestination";
import * as i18n from "util/i18n";
import ContactSummaryBody from "./_components/ContactSummary";

const DeleteSummaryPage = () => {
    const { frequentDestinationDelete } = useSelector((state) => state.contactDestination);
    const { contactTicket } = useSelector((state) => state.contactDestination);
    const { dispatch } = useConfirmTransaction(frequentDestinationDelete, contactTicket, "contactDestination");

    const { id } = useParams();

    useEffect(() => {
        if (isEmpty(frequentDestinationDelete)) {
            dispatch(contactActions.deleteFrequentDestinationPreviewRequest({ idFrequentDestination: id }));
        }
    }, []);

    return (
        <>
            <Notification scopeToShow="frequentDestinationDeleteConfirmation" />
            <ResponsiveHeader id="frequentDestination.delete.title" />
            <MainContainer showLoader={false}>
                <div className="container">
                    {isEmpty(frequentDestinationDelete) ? (
                        <Loader />
                    ) : (
                        <>
                            <h2 className="text-lead" style={{ fontWeight: 500 }}>
                                {i18n.get("frequentDestination.modify.subtitle")}
                            </h2>
                            <ContactSummaryBody
                                accountNumber={frequentDestinationDelete.accountNumber}
                                productType={frequentDestinationDelete?.productType}
                                cbu={frequentDestinationDelete.cbu}
                                name={frequentDestinationDelete.name}
                                localBank={frequentDestinationDelete.localBank}
                                recipientEmail={frequentDestinationDelete.recipientEmail}
                                recipientDocumentType={frequentDestinationDelete.recipientDocumentType}
                                recipientDocumentNumber={frequentDestinationDelete.recipientDocumentNumber}
                                recipientName={frequentDestinationDelete.recipientName}
                            />
                        </>
                    )}
                    <GeneralCredentialForm
                        hideIndications
                        transactionData={frequentDestinationDelete}
                        action={contactActions.deleteFrequentDestinationRequest}
                        idActivity="destinations.delete"
                    />
                </div>
            </MainContainer>
        </>
    );
};

export default DeleteSummaryPage;
